import Icon, {
	DownOutlined,
	FormOutlined,
	LeftOutlined,
} from "@ant-design/icons";
import { Dropdown, Form, Input, Menu, Space, Typography } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import React, { useEffect, useState } from "react";
import { DataCourse, DataModule, IClass, MenuItem, statusTypes } from "types";
import { ReactComponent as forumIcon } from "assets/forumIcon.svg";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import {
	AddBlockContentModal,
	AddClassModal,
	EditBlockContentModal,
	EditClassModal,
	ViemForumModal,
} from "components";
import { useLocation } from "react-router-dom";
import { api } from "services/api";
import { getItem } from "utils/getItem";
import ProcessingModal from "components/Modals/ProcessingModal";
// import URLHelper from "utils/url";

export const ManageClasses: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEditClass, setIsOpenEditClass] = useState<boolean>(false);
	const [isOpenBlock, setIsOpenBlock] = useState<boolean>(false);
	const [isOpenEditBlock, setIsOpenEditBlock] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [editMode, setEditMode] = useState<boolean>(false);
	const [processing, setProcessing] = useState<boolean>(false);
	const [currentClassInfo, setCurrentClassInfo] = useState<IClass>();
	const [isOpenForum, setIsOpenForum] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [files, setFiles] = useState<{ [k: string]: string }>({
		image: "",
		video: "",
		archive: "",
	});
	const [blocks, setBlocks] = useState<any[]>([]);
	const [selectedBlockId, setSelectedBlockId] = useState<number>(0);
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [classes, setClasses] = useState<IClass[]>();
	const [fromCreate, setFromCreate] = useState<boolean>(false);
	// @ts-ignore
	const { state }: { state: { data: DataModule; generalState: DataCourse } } =
		useLocation();
	const [form] = Form.useForm();
	const [editClassForm] = Form.useForm();

	const items: MenuItem[] = [
		getItem("10", "10"),
		getItem("20", "20"),
		getItem("30", "30"),
		getItem("40", "40"),
	];
	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={items}
		/>
	);
	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (classes) {
			const {
				data: {
					data: { class: courseClass, forum },
				},
			} = await api.get(`/classes/${id}`);
			setIsLoading(false);

			setCurrentClassInfo({ ...courseClass, forum });
		}
	};

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "30%",
				};
			},
		},
		{
			title: "Criado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Autor",
			dataIndex: "author",
			key: "author",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => <p style={{ margin: 0 }}>{statusTypes[status]}</p>,
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						title="Editar"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEditClass(true);
						}}
					/>
					<Icon
						component={forumIcon}
						style={{ fontSize: "28px" }}
						className="group"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenForum(true);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setClasses(undefined);
		api
			.get(
				`/modules/${
					state.data.id
				}/classes?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				const dataWithKeys = res.data.data.classes.map(
					(item: any, index: any) => {
						return {
							...item,
							key: index,
						};
					}
				);
				setTotalItensValue(Number(res?.data?.pagination?.total));
				setClasses(dataWithKeys);
				// URLHelper.addParam("perPage", selectedValue);
			});
	}, [state, isOpen, isOpenEditClass, selectedValue, paginationInfo]);

	return (
		<div className="m-classes">
			<AddClassModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				fromCreate={fromCreate}
				setFromCreate={setFromCreate}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpenBlock={setIsOpenBlock}
				courseStatus={courseStatus}
				blocks={blocks}
				setBlocks={setBlocks}
				setCourseStatus={setCourseStatus}
				setSelectedBlockId={setSelectedBlockId}
				setIsOpenEditBlock={setIsOpenEditBlock}
				setProcessing={setProcessing}
				titlePage={`Módulo - ${state.data.title}`}
				courseId={state.data.id}
			/>
			<EditBlockContentModal
				form={form}
				isOpen={isOpenEditBlock}
				setIsOpen={setIsOpenEditBlock}
				files={files}
				setFiles={setFiles}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				setEditMode={setEditMode}
				blocks={blocks}
				setBlocks={setBlocks}
				setFromCreate={setFromCreate}
				fromCreate={fromCreate}
				setProcessing={setProcessing}
				setSelectedBlockId={setSelectedBlockId}
				selectedBlockId={selectedBlockId}
			/>
			<AddBlockContentModal
				form={form}
				isOpen={isOpenBlock}
				setIsOpen={setIsOpenBlock}
				files={files}
				setFiles={setFiles}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				setBlocks={setBlocks}
				setFromCreate={setFromCreate}
				setProcessing={setProcessing}
				fromCreate={fromCreate}
				currentClassInfo={currentClassInfo}
			/>

			<EditClassModal
				form={editClassForm}
				isOpen={isOpenEditClass}
				setIsOpen={setIsOpenEditClass}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpenBlock={setIsOpenBlock}
				courseStatus={courseStatus}
				blocks={blocks}
				setBlocks={setBlocks}
				setEditMode={setEditMode}
				editMode={editMode}
				setProcessing={setProcessing}
				setCourseStatus={setCourseStatus}
				setSelectedBlockId={setSelectedBlockId}
				setIsOpenEditBlock={setIsOpenEditBlock}
				isOpenEditBlock={isOpenEditBlock}
				currentClassInfo={currentClassInfo}
				titlePage={`Módulo - ${state.data.title}`}
				courseId={state.data.id}
			/>
			<ViemForumModal
				setIsOpen={setIsOpenForum}
				isOpen={isOpenForum}
				currentCourseData={currentClassInfo}
				isCourse={false}
			/>
			<ProcessingModal visible={processing} />

			<div className="m-classes__container">
				<div
					style={{
						display: "flex",
						width: "100%",
						alignItems: "center",
						marginBottom: "0.9em",
					}}
				>
					<LeftOutlined
						style={{ fontSize: "20px", marginRight: "20px" }}
						onClick={() => window.history.back()}
					/>
					<h1 className="m-classes__container__title">
						Curso - {state.generalState.title} - {state.data.title}
					</h1>
				</div>
				<div className="m-classes__container__input">
					<div className="m-classes__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						aulas
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-classes__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Aula
					</button>
				</div>
				<Table
					//@ts-ignore
					columns={columns}
					dataSource={classes}
					loading={classes === undefined || isLoading}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
